/**
 * Verify a Google reCAPTCHA v2 token with Google's siteverify API.
 * Skipped in local development (`next dev` / NODE_ENV=development).
 */

/** True when running locally via `next dev` (or DISABLE_RECAPTCHA=true). */
export function isRecaptchaBypassed(): boolean {
  return (
    process.env.NODE_ENV === 'development' ||
    process.env.DISABLE_RECAPTCHA === 'true' ||
    process.env.NEXT_PUBLIC_DISABLE_RECAPTCHA === 'true'
  )
}

export async function verifyRecaptchaToken(token: string): Promise<{
  ok: boolean
  error?: string
}> {
  if (isRecaptchaBypassed()) {
    return { ok: true }
  }

  const secret = process.env.RECAPTCHA_SECRET_KEY
  if (!secret) {
    return { ok: false, error: 'reCAPTCHA is not configured on the server.' }
  }

  if (!token || typeof token !== 'string' || token.length > 4000) {
    return { ok: false, error: 'Please complete the reCAPTCHA challenge.' }
  }

  try {
    const body = new URLSearchParams({
      secret,
      response: token,
    })

    const res = await fetch('https://www.google.com/recaptcha/api/siteverify', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body,
    })

    if (!res.ok) {
      return { ok: false, error: 'reCAPTCHA verification failed. Please try again.' }
    }

    const data = (await res.json()) as {
      success?: boolean
      'error-codes'?: string[]
    }

    if (!data.success) {
      return { ok: false, error: 'reCAPTCHA verification failed. Please try again.' }
    }

    return { ok: true }
  } catch (error) {
    console.error('reCAPTCHA verify error:', error)
    return { ok: false, error: 'reCAPTCHA verification failed. Please try again.' }
  }
}
